import React, { useState } from 'react';
import { Modal, Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import { RiCloseLine  } from 'react-icons/ri';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import BaseButton from '../../BaseButton';
import BaseImage from '../../BaseImage';
import { Viewer, Worker, SpecialZoomLevel  } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { zoomPlugin } from '@react-pdf-viewer/zoom';

import DownloadIcon from '../../../assets/images/reports-icons/pdf-modal-download-icon.svg';

const PdfViewerModal = ({ open, onClose, file, fileName }) => {
    const zoomPluginInstance = zoomPlugin();
    const { ZoomIn, ZoomOut } = zoomPluginInstance;
    const md = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const handleDocumentLoad = (e) => {
        setTotalPages(e.doc.numPages);
    };
    const handlePageChange = (e) => {
        setCurrentPage(e.currentPage + 1);
    };
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = file;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <Modal
        open={open}
        onClose={onClose}
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
        >
        <Box
            sx={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                width: '90%',
                height: '95%',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                p: '0 18px',
                height: '64px',
                background: '#ECEFF1'
            }}>
                <Typography 
                    variant={md ? "h2" : "h4"}
                    color="primary.black"
                >{fileName}</Typography>
                <IconButton sx={{color: '#000'}} onClick={onClose}>
                    <RiCloseLine size={md ? 48 : 32} />
                </IconButton>
            </Box>
            
            <Box sx={{ 
                    flex: 1, 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    height: 'calc(100% - 128px)' ,
                    padding: '16px 25px',
                    background: '#0E0F1080'
                }}
            >
                <Box 
                    sx={{height: 'calc(100% - 32px)', overflowY: 'scroll', width: '100%'}}
                    className='notification-dropdown-scroll'
                >
                    <Box sx={{height: 'fit-content', width: '100%'}}>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                            <Viewer 
                                fileUrl={file}
                                defaultScale={SpecialZoomLevel.PageWidth}
                                onDocumentLoad={handleDocumentLoad}
                                onPageChange={handlePageChange}
                                plugins={[zoomPluginInstance]}
                            />
                        </Worker>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                p: '7px 18px',
                height: '64px',
                background: '#ECEFF1'
            }}>
                <Typography 
                    variant={md ? "h2" : 'h4'}
                    color="primary.black"
                >Page {currentPage} of {totalPages}</Typography>
                <Box sx={{
                    display: 'flex',
                    gap: {
                        xs: 1,
                        md: 4
                    },
                    background: '#ABB7C04D',
                    borderRadius: 4,
                    width: 'fit-content',
                    height: '100%',
                    padding: '6px 12px'
                }}>
                    <ZoomOut>
                        {
                            (props) => (
                                <IconButton 
                                    sx={{
                                        color: 'primary.black',
                                        padding: 0
                                    }}
                                    onClick={() => props.onClick()}
                                >
                                    <ZoomOutIcon sx={{
                                        width: {
                                            xs: '32px',
                                            md: '48px'
                                        },
                                        height: {
                                            xs: '32px',
                                            md: '48px'
                                        },
                                    }}  />
                                </IconButton>
                            )
                        }
                    </ZoomOut>
                    <ZoomIn>
                        {
                            (props) => (
                                <IconButton 
                                    sx={{
                                        color: 'primary.black',
                                        padding: 0
                                    }}
                                    onClick={() => props.onClick()}
                                >
                                    <ZoomInIcon sx={{
                                        width: {
                                            xs: '32px',
                                            md: '48px'
                                        },
                                        height: {
                                            xs: '32px',
                                            md: '48px'
                                        },
                                    }}/>
                                </IconButton>
                            )
                        }
                    </ZoomIn>
                </Box>
                <BaseButton
                    buttonType={'primary'}
                    sx={{
                        width: 'fit-content',
                        height: '44px',
                        display: 'flex',
                        gap: {
                            xs: '4px',
                            md: '8px'
                        }
                    }}
                    onClick={handleDownload}
                >
                    <BaseImage
                        sx={{
                            width: {
                                xs: '16px',
                                md: '20px'
                            },
                            height: {
                                xs: '16px',
                                md: '20px'
                            },
                            display: 'flex'
                        }}
                        sximage={{display: 'flex'}}
                        src={DownloadIcon}
                        alt="icon-download"
                    />
                    <Typography variant={md ? "body" : 'subText'} color='white' mr='2'>
                        Download PDF
                    </Typography>
                </BaseButton>
            </Box>
        </Box>
        </Modal>
    );
};

export default PdfViewerModal;
